"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApCheckbox = void 0;
var React = require("react");
var ApIcon_1 = require("../ApIcon");
var styles_1 = require("./styles");
var ApCheckLabel_1 = require("../../internal/ApCheckLabel");
var types_1 = require("../../utils/types");
exports.ApCheckbox = function (_a) {
    var flexDirection = _a.flexDirection, indeterminate = _a.indeterminate, justifyContent = _a.justifyContent, id = _a.id, className = _a.className, children = _a.children, theme = _a.theme, props = __rest(_a, ["flexDirection", "indeterminate", "justifyContent", "id", "className", "children", "theme"]);
    return (React.createElement(ApCheckLabel_1.StyledCheckLabel, { title: id, htmlFor: id, flexDirection: children ? flexDirection : 'row', justifyContent: children ? justifyContent : 'flex-start', tabIndex: 0, theme: theme },
        React.createElement(styles_1.StyledCheckWrapper, { disabled: props.disabled },
            React.createElement(styles_1.StyledCheckInput, __assign({}, props, { id: id, type: props.type, defaultChecked: props.defaultChecked })),
            indeterminate
                ? (React.createElement(styles_1.StyledIndeterminateIcon, null,
                    React.createElement(ApIcon_1.ApIcon, { iconName: "indeterminate", iconSize: "24px" })))
                : (React.createElement(styles_1.StyledCheckIcon, { className: "ap-checkbox " + (className ? className : '') },
                    React.createElement(ApIcon_1.ApIcon, { iconName: "checkbox", iconSize: "24px" })))),
        children && React.createElement(ApCheckLabel_1.StyledCheckChild, null, children)));
};
exports.ApCheckbox.defaultProps = {
    autoFocus: false,
    disabled: false,
    theme: types_1.LIGHT,
    type: 'checkbox'
};
//# sourceMappingURL=ApCheckbox.js.map